<template>
  <main role="main">
    <b-container class="py-4" style="max-width: 400px;">
      <h4>{{ $t("changePassword") }}</h4>
      <b-alert v-if="formErrorMsg" variant="danger" show>{{ formErrorMsg }}</b-alert>

      <b-form @submit.prevent="submitForm">
        <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
        <template v-if="!isLoading && passwordPolicy">
          <b-form-group :description="passwordPolicy.passwordDescription">
            <template v-slot:label>{{ $t("newPassword") }} <span class="text-danger">*</span></template>
            <b-form-input type="password" required v-model="newPassword" autocomplete="new-password"
                          :minlength="passwordPolicy.minPasswordLength"
                          :maxlength="passwordPolicy.maxPasswordLength"
                          :pattern="passwordPolicy.passwordPattern"
                          @invalid.native="$event.target.setCustomValidity(passwordPolicy.passwordValidationFailedMessage)"
                          @input.native="$event.target.setCustomValidity('')"/>
          </b-form-group>
          <b-form-group>
            <template v-slot:label>{{ $t("confirmPassword") }} <span class="text-danger">*</span></template>
            <b-form-input type="password" required v-model="confirmPassword" autocomplete="new-password"/>
          </b-form-group>

          <div class="text-center pt-3">
            <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
          </div>
        </template>
      </b-form>
    </b-container>

  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import BaseComponent from "@/components/BaseComponent";
  import environment from "@/environment";
  import * as userService from "@/service/userService";
  import * as passwordPolicyService from "@/service/passwordPolicyService";

  @Component
  export default class ResetPassword extends BaseComponent {

    isLoading = true;
    passwordPolicy = null;

    newPassword = "";
    confirmPassword = "";

    formErrorMsg = "";
    isSubmitting = false;

    secretKey: string = decodeURIComponent(this.$route.params.secretKey);


    mounted() {
      this.secretKey = decodeURIComponent(this.$route.params.secretKey);
      this.fetchPasswordPolicy();
    }

    async fetchPasswordPolicy() {
      try {
        this.isLoading = true;
        this.passwordPolicy = await passwordPolicyService.get();

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
      }
    }

    async submitForm() {
      this.formErrorMsg = null;

      if (this.newPassword !== this.confirmPassword) {
        this.formErrorMsg = this.$t("passwordsNotMatch").toString();
        return;
      }

      try {
        this.isSubmitting = true;
        await userService.userResetPassword(this.newPassword,{
          secretKey: this.secretKey,
        });

        this.showSuccessModal();

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

    async showSuccessModal() {
      await this.$bvModal.msgBoxOk(this.$t("passwordResetSuccessful").toString(), {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true
      });
      userService.signOut();
    }

  }
</script>
